module.exports = __webpack_public_path__ + "61fce03abd2e595975b8454fef7736ac.jpg";